<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <div>
        <el-button
          v-access:add
          icon="el-icon-plus"
          size="small"
          @click="btnAdd"
          :disabled="isloading"
          type="primary"
          >新增班级</el-button
        >
      </div>
      <el-table
        border
        hightlight-current-row
        style="width: 100%"
        :header-cell-class-name="headerRow"
        :data="classModel"
        :max-height="tableMaxHeight()"
        v-loading="isloading"
      >
        <el-table-column
          prop="ClassName"
          label="班级名称"
          sortable
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="ClassType"
          label="班级类型"
          sortable
          :formatter="ClassType"
        ></el-table-column>
        <el-table-column
          prop="StuNum"
          label="班级人数"
          sortable
          align="right"
        ></el-table-column>
        <el-table-column
          prop="IsReachSize"
          label="是否达到开班人数"
          sortable
          :formatter="IsReachSize"
        ></el-table-column>
        <el-table-column
          prop="IsClassed"
          label="是否已开班"
          sortable
          :formatter="IsClassed"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-access:read
              @click="innerReadClass(scope.row)"
              type="text"
              size="mini"
              >详情</el-button
            >
            <el-button
              v-access:modify
              @click="innerUpdateisClass(scope.row)"
              type="text"
              size="mini"
              v-if="scope.row.IsClassed !== true"
              >确认开班</el-button
            >
            <el-button
              v-access:modify
              @click="innerTransfer(scope.row)"
              type="text"
              size="mini"
              >调班</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wapper">
        <OfPagination
          :total="total"
          :pageSize="pageSize"
          :currentPage="currentPage"
          @onSizeChange="handleSizeChange"
          @onCurrentChange="handleCurrentChange"
        ></OfPagination>
      </div>
      <!--新增班级-->
      <el-dialog
        :title="materialstitle"
        :visible.sync="materialsdialog"
        width="80%"
        :before-close="handleClose"
        append-to-body
        :close-on-click-modal="false"
        class="fistdig"
      >
        <div class="el-dialog-div">
          <el-form
            ref="dataForm1"
            :model="dataForm1"
            :disabled="isdisableds1"
            :rules="materialsRules"
          >
            <el-button
              v-access:add
              icon="el-icon-plus"
              size="small"
              @click="btnAddPerson"
              :disabled="isloading"
              type="primary"
              v-if="this.dataForm2.Id === undefined"
              >选择报名人员</el-button
            >
            <el-button
              v-access:add
              icon="el-icon-plus"
              size="small"
              @click="btnAddPerson"
              :disabled="isloading"
              type="primary"
              >添加培训人员</el-button
            >
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="personalModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="Name"
                label="报名人员"
                sortable
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Phone"
                label="联系电话"
                sortable
              ></el-table-column>
              <el-table-column
                prop="MemberType"
                label="报名人员类型"
                sortable
                align="right"
                :formatter="MemberType"
              ></el-table-column>
              <el-table-column
                prop="SignUpNum"
                label="报名人数"
                sortable
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:read
                    @click="innerRead(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                  <el-button
                    @click="removePeople(scope.row)"
                    type="text"
                    size="mini"
                    >移除名单</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <span slot="footer">
          <el-button @click="materialsdialog = false">取 消</el-button>
          <el-button
            type="primary"
            @click="addmaterialsdialog()"
            v-if="this.dataForm2.Id === undefined"
            >提 交</el-button
          >
        </span>
        <div class="pagination-wapper">
          <OfPagination
            :total="total2"
            :pageSize="pageSize2"
            :currentPage="currentPage2"
            @onSizeChange="handleSizeChange2"
            @onCurrentChange="handleCurrentChange2"
          ></OfPagination>
        </div>
      </el-dialog>
      <!--选择人员-->
      <el-dialog
        :title="materialstitletoadd"
        :visible.sync="materialsdialogtoadd"
        width="80%"
        :before-close="handleClose"
        append-to-body
        :close-on-click-modal="false"
      >
        <div class="el-dialog-div">
          <el-form ref="dataForm2" :model="dataForm2" :disabled="isdisableds2">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="addpersonalModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
              @selection-change="onSelectionChange"
              ref="multipleTable"
            >
              <el-table-column
                type="selection"
                width="50"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Name"
                label="报名人员"
                sortable
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Phone"
                label="联系电话"
                sortable
              ></el-table-column>
              <el-table-column
                prop="MemberType"
                label="报名人员类型"
                sortable
                align="right"
                :formatter="MemberType"
              ></el-table-column>
              <el-table-column
                prop="SignUpNum"
                label="报名人数"
                sortable
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:read
                    @click="innerRead(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <span slot="footer">
          <el-button @click="materialsdialogtoadd = false">取 消</el-button>
          <el-button type="primary" @click="addmaterialsdialogtoadd()"
            >确 定</el-button
          >
        </span>
        <div class="pagination-wapper">
          <OfPagination
            :total="total3"
            :pageSize="pageSize3"
            :currentPage="currentPage3"
            @onSizeChange="handleSizeChange3"
            @onCurrentChange="handleCurrentChange3"
          ></OfPagination>
        </div>
      </el-dialog>
      <!--选择调班-->
      <el-dialog
        :title="transferClasstitle"
        :visible.sync="transferClassdialog"
        width="30%"
        :before-close="handleClose"
        append-to-body
        :close-on-click-modal="false"
      >
        <div class="el-dialog-div">
          <el-form ref="dataForm3" :model="dataForm3" :disabled="isdisableds3">
            <el-form-item label="培训活动：">
              <el-select v-model="dataForm3.TrainId" placeholder="请选择">
                <el-option
                  v-for="item in libraryList"
                  :key="item.Id"
                  :label="item.Title"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer">
          <el-button @click="transferClassdialog = false">取 消</el-button>
          <el-button type="primary" @click="addtransferClassdialog()"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      headerRow: "header-row",
      isConfirm: false,
      isdisabled: false,
      isloading: false,
      width: "80%",
      classModel: [],
      personalModel: [],
      addpersonalModel: [],
      groupModel: [],
      activeName: "personal",
      total: 0,
      currentPage: 1,
      pageSize: 15,
      total2: 0,
      currentPage2: 1,
      pageSize2: 15,
      total3: 0,
      currentPage3: 1,
      pageSize3: 15,
      type: 0,
      itemKey: "OF.RC.Professional",
      professionalOptions: [],
      formData: {},
      materialsdialog: false,
      materialsdialogtoadd: false,
      transferClassdialog: false,
      materialstitle: "",
      materialstitletoadd: "",
      transferClasstitle: "",
      dataForm1: {},
      dataForm2: {},
      dataForm3: {},
      isdisableds1: false,
      isdisableds2: false,
      isdisableds3: false,
      materialsRules: {
        ClassName: {
          required: true,
          message: "请输入班级名称",
          trigger: "blur",
        },
      },
      batchId: "", // 默认选中报名人员
      Totalnum: 0,
      SaveClassData: [],
      libraryList: [],
      CallBackdata: null,
      TrainIdstr: "",
    };
  },
  mounted() {
    this.loadData();
  },
  components: {
    OfDialog,
    OfPagination,
  },
  computed: {},
  methods: {
    //新增
    btnAdd() {
      this.dataForm1 = {};
      this.dataForm2 = {};
      this.personalModel = [];
      this.total2 = 0;
      this.materialstitle = "新增班级";
      this.materialsdialog = true;
    },
    btnAddPerson() {
      this.loadDatabyclassId();
      this.materialstitletoadd = "选择报名人员";
      this.materialsdialogtoadd = true;
    },
    selectDefaultRow() {
      let vm = this;
      this.addpersonalModel;
      this.$nextTick(() => {
        this.addpersonalModel.forEach((row) => {
          this.personalModel.forEach((item) => {
            if (item.Id === row.Id) {
              vm.$refs.multipleTable.toggleRowSelection(row, true);
            }
          });
        });
      });
    },
    removePeople(item) {
      this.$confirm("是否此名单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api
            .deleteStu(item.Id)
            .then((res) => {
              if (res.data.Code === 0) {
                this.$message({
                  message: "移除成功",
                  type: "success",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    addmaterialsdialog() {
      if (this.batchId === "") {
        return this.$message({
          message: "报名人员不能为空",
          type: "error",
        });
      }
      this.SaveClassData.Id = this.batchId;
      this.SaveClassData.ClassType = 1;
      this.SaveClassData.StuNum = this.Totalnum;
      this.SaveClassData.TrainId = this.dataForm.Id;
      let params = Object.assign({}, this.SaveClassData);
      api
        .TrainClassSave(params)
        .then((rep) => {
          this.isConfirm = false;
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.formCallBackClass(params);
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.isConfirm = false;
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    onSelectionChange(rowItems) {
      if (rowItems.length) {
        const ids = [];
        for (var i = 0; i < rowItems.length; i++) {
          ids.push(rowItems[i].Id);
        }
        this.batchId = ids.join(",");
      }
    },
    addmaterialsdialogtoadd() {
      this.materialsdialogtoadd = false;
      this.loadDatabyIdList();
    },
    handleClose(done) {
      done();
    },
    ClassType(rowData) {
      return rowData.ClassType == 0 ? "独立班" : "非独立班";
    },
    IsReachSize(rowData) {
      return rowData.IsReachSize == 0 ? "否" : "是";
    },
    IsClassed(rowData) {
      return rowData.IsClassed == 0 ? "否" : "是";
    },
    MemberType(rowData) {
      return rowData.MemberType == 1 ? "个人" : "团体";
    },
    istypename() {
      this.dataForm.TypeName != undefined
        ? (this.isdisabled = true)
        : (this.isdisabled = false);
    },
    cancel() {
      this.$emit("formCallBack", this.CallBackdata);
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    //改变分页大小
    handleSizeChange2(val) {
      this.currentPage2 = 1;
      this.pageSize2 = val;
      this.loadDatabyIdList();
    },
    //改变当前页码
    handleCurrentChange2(val) {
      if (this.total2 > this.pageSize2) {
        this.currentPage2 = val;
        this.loadDatabyIdList();
      }
    },
    //改变分页大小
    handleSizeChange3(val) {
      this.currentPage3 = 1;
      this.pageSize3 = val;
      this.loadDatabyclassId();
    },
    //改变当前页码
    handleCurrentChange3(val) {
      if (this.total3 > this.pageSize3) {
        this.currentPage3 = val;
        this.loadDatabyclassId();
      }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //初始化数据
    loadData() {
      api
        .QueryByClass(this.currentPage, this.pageSize, this.dataForm.Id)
        .then((rep) => {
          if (rep.data.Code === 0) {
            this.total = rep.data.Data.total;
            this.classModel = rep.data.Data.rows;
          }
        });
    },
    loadDatabyclassId() {
      var classid = this.dataForm2.Id === undefined ? "" : this.dataForm2.Id;
      api
        .QueryByClassId(
          this.currentPage3,
          this.pageSize3,
          this.dataForm.Id,
          classid
        )
        .then((rep) => {
          if (rep.data.Code === 0) {
            if (classid === "") {
              this.total3 = rep.data.Data.total;
              this.addpersonalModel = rep.data.Data.rows;
            } else {
              this.total2 = rep.data.Data.total;
              this.personalModel = rep.data.Data.rows;
            }
            this.selectDefaultRow();
          }
        });
    },
    loadDatabyIdList() {
      if (this.batchId != "")
        api
          .QueryByIdList(this.currentPage2, this.pageSize2, this.batchId)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.total2 = rep.data.Data.total;
              this.personalModel = rep.data.Data.rows;
              this.Totalnum = this.personalModel[0].Totalnum;
            }
          });
      this.selectDefaultRow(); // 默认选中表格
    },
    IsVolunteer(rowData) {
      return rowData.IsVolunteer == 0 ? "否" : "是";
    },
    Sex(rowData) {
      return rowData.Sex == 0 ? "女" : "男";
    },
    IsPay(rowData) {
      return rowData.IsPay == 0 ? "未支付" : "已支付";
    },
    Professional(rowData) {
      this.professionalOptions.forEach((item) => {
        if (item.data.ItemValue == rowData.Professional) {
          return item.text;
        }
      });
    },
    innerUpdateisClass(rowData) {
      var tips = "请确认是否开班？";
      if (rowData.StuNum < this.dataForm.MinimumPeople) {
        tips = "班级人数未达到最低开班人数，请确认是否开班？";
      }
      this.$confirm(tips, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api
          .UpdateIsClassed(rowData.Id)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.loadData();
              this.isloading = false;
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.isConfirm = false;
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
      this.formData = rowData;
      this.formVisible = true;
    },
    innerRead(rowData) {
      this.formData = rowData;
      this.formVisible = true;
    },
    innerReadClass(rowData) {
      this.materialstitle = "班级详情";
      this.dataForm2 = rowData;
      this.materialsdialog = true;
      this.loadDatabyclassId();
    },
    innerTransfer(rowData) {
      this.TrainIdstr = rowData.TrainId;
      this.dataForm3.Id = rowData.Id;
      this.transferClasstitle = "调班";
      this.transferClassdialog = true;
      this.getLibraryOption();
    },
    getLibraryOption() {
      api.querylifeGuard(this.TrainIdstr).then((rep) => {
        if (rep.data.Code === 0) {
          this.libraryList = rep.data.Data;
        }
      });
    },
    addtransferClassdialog() {
      api
        .TransfertoClass(this.dataForm3)
        .then((rep) => {
          this.isConfirm = false;
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.transferClassdialog = false;
            this.loadData();
            this.CallBackdata = this.dataForm3;
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.isConfirm = false;
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    formCallBackClass(data) {
      this.materialsdialog = false;
      if (data != null) {
        this.loadData();
      }
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload-list__item-delete {
  display: none !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
</style>

<style>
.hide .el-upload--fileList {
  display: none;
}
</style>
